"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyConfigurationModel = exports.emptyConfigurationModelUseableDef = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const ConfigurationModel_1 = require("./ConfigurationModel");
exports.emptyConfigurationModelUseableDef = {
    parent: ConfigurationModel_1.configurationModelUseableDef,
    validation: {
        Kette: false,
        Espool: false,
    },
};
exports.isEmptyConfigurationModel = echain_shared_modelling_1.UseableUtil.createGuard(exports.emptyConfigurationModelUseableDef);
//# sourceMappingURL=EmptyConfigurationModel.js.map